export const addBusinessDays = (
  startDate: Date,
  noOfDayToAdd: number
): Date => {
  let remainingDays = noOfDayToAdd;
  const newDate = new Date(startDate);

  while (remainingDays > 0) {
    newDate.setDate(newDate.getDate() + 1);
    if (!isWeekend(newDate)) {
      remainingDays--;
    }
  }

  return newDate;
};

export const removeBusinessDays = (
  startDate: Date,
  noOfDayToAdd: number
): Date => {
  let remainingDays = noOfDayToAdd;
  const newDate = new Date(startDate);

  while (remainingDays > 0) {
    newDate.setDate(newDate.getDate() - 1);
    if (!isWeekend(newDate)) {
      remainingDays--;
    }
  }

  return newDate;
};

export const isWeekend = (date: Date): boolean => {
  const weekDay = date.getDay();
  return weekDay === 0 || weekDay === 6;
};

export const getUsDateString = (date: Date): string =>
  date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });

export const getDayOfYear = (date: Date): number =>
  Math.floor(
    (date.valueOf() - new Date(date.getFullYear(), 0, 0).valueOf()) /
      (1000 * 60 * 60 * 24)
  );

export const compareDateOnly = (date1: Date, date2: Date): number => {
  if (date1.getFullYear() != date2.getFullYear()) {
    return date1.valueOf() - date2.valueOf();
  }

  const dayOfYear1 = getDayOfYear(date1);
  const dayOfYear2 = getDayOfYear(date2);

  return dayOfYear1 - dayOfYear2;
};
